import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/*
 * Menu interface
 */
export interface Menu {
  state: any;
  name?: string;
  type?: string;
  icon?: string;
  children?: ChildrenItems[];
  id?: string
}

/*
 * Children menu interface
 */
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}



@Injectable()
export class MenuItems {
  
  HEADERMENUITEMS = [
    {
      state: "home",
      name: this.translate.instant("header.home"),
      type: "custom",
      fragment: "home",
    },
    {
      state: "home",
      name: this.translate.instant("header.method"),
      type: "fragment",
      fragment: "metodologia"
    },
    {
      state: "home",
      name: this.translate.instant("header.courses"),
      type: "fragment",
      fragment: "cursos"
    },
    {
      state: "home",
      name: this.translate.instant("header.pricing"),
      type: "fragment",
      fragment: "planos"
    },
    {
      state: "home",
      name: this.translate.instant("header.faqs"),
      type: "fragment",
      fragment: "faqs"
    },
    {
      state: "blog",
      name: "Blog",
      type: "blog"
   },
    {
      state: "ebooks",
      name: "Ebooks",
      type: "blog"
   }
  ];

  AUTHITEMS = [
    {
      state: ["logged", "home"],
      name: this.translate.instant("header.home_logged"),
      type: "nested"
    },
    {
      state: ["courses", "aula"],
      name: this.translate.instant("header.rooms"),
      type: "nested"
    },
    {
      state: ["logged", "quest"],
      name: this.translate.instant("header.quest"),
      type: "nested"
    },
    {
      state: ["logged", "messages"],
      name: this.translate.instant("header.messages"),
      type: "nested",
      id: 'messages'
    },
    {
      state: ["logged", "faqs"],
      name: this.translate.instant("header.support"),
      type: "nested"
    },
    {
      state: ["ebooks"],
      name: "E-books",
      type: "ebook"
   },
    {
      state: ["logged", "profile"],
      name: this.translate.instant("header.profile"),
      type: "nested"
    },

  ];

  constructor(public translate: TranslateService) { }

  /*
   * Get all header menu
   */
  getMainMenu(): Menu[] {
    return this.HEADERMENUITEMS;
    //  return HEADERMENUITEMS;
  }

  getAuthMenu(): Menu[] {
    return this.AUTHITEMS;
  }
}
